import Link from 'next/link';

interface Props {
  children: React.ReactNode;
  colorSwap?: boolean;
  href: string;
  prefetch?: boolean;
  target?: '_blank' | '_self' | '_parent' | '_top';
}

export default function BurnoutButtonLinkNext({ children, colorSwap, href, prefetch = true, target }: Props) {
  if (colorSwap) {
    return (
      <Link
        target={target}
        prefetch={prefetch}
        href={href}
        className='bg-burnout-dark-gray hover:bg-burnout-light-gray border-burnout-blue nice-hover-burnout w-full rounded-lg border-2 px-3 py-2 text-center font-bold text-white transition-all duration-200 ease-in-out hover:text-black'
      >
        {children}
      </Link>
    );
  }

  return (
    <Link
      target={target}
      prefetch={prefetch}
      href={href}
      className='bg-burnout-light-gray hover:bg-burnout-dark-gray border-burnout-blue nice-hover-burnout w-full rounded-lg border-2 px-3 py-2 text-center font-bold text-black transition-all duration-200 ease-in-out hover:text-white'
    >
      {children}
    </Link>
  );
}
